import mrpStyles from './../mrp.json'

export default {
  name: '4',
  color: mrpStyles.colors.SecondaryGreyMetal,
  inverseColor: mrpStyles.colors.PrimaryWhite
}
